import React from "react";
import { Button, Card, Col, Form, Input, Row, Alert } from "antd";
import ProfileBox from "./ProfileBox";
import api_url from '../../../utils/requestApi'
import ServerApi from '../../../utils/ServerApi'
import appConst from '../../../constents/app.const'

class PasswordUpdate extends React.Component{
    constructor(props){
        super(props)
    }
    formRef = React.createRef()
    state={
        authFail: false,
        authFailMsg: 'Input your credential'
    }
    componentDidMount(){}
    onReset = () => {
        this.formRef.current.resetFields()
    }
    onFinish= (e) => {
        const serverApi = new ServerApi(appConst.apiUrl, this.props.token)
        serverApi.account_actions(api_url.password_update, 'PATCH', e, returnData => {
            if(returnData.success == 1){
                this.setState({
                    authFail: false,
                    authFailMsg: returnData.message
                }, () => {
                    this.onReset()
                })
            }else{
                this.setState({
                    authFail: true,
                    authFailMsg: returnData.message
                })
            }
        })
    }
    render(){
        return(
            <div>
                <Row>
                    <Col xs={0} sm={0} md={0} lg={6} xl={6}></Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}
                        style={{background: 'white'}}
                    >
                        <Card>
                            <Row>
                                <Col xs={0} sm={0} md={0} lg={8} xl={8}>
                                    <ProfileBox userInfo={this.props.userInfo?this.props.userInfo:'Name'}/>
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={16} xl={16}>
                                    <u className="ml-5"><h5>Password Update</h5></u>
                                    {this.state.authFail ? <Alert message={this.state.authFailMsg} type="error" showIcon /> : 
                                    <Alert message={this.state.authFailMsg} type="success" showIcon />}
                                    <Form
                                        ref ={this.formRef}
                                        onFinish={this.onFinish}
                                    >
                                        <div className="pb-10">
                                            <label>Old Password</label>
                                            <Form.Item
                                                name="current_password"
                                                rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input old password!',
                                                },
                                                ]}
                                            >
                                            <Input.Password placeholder="old password"/>
                                            </Form.Item>
                                        </div>
                                        <div className="pb-10">
                                            <label>New Password</label>
                                            <Form.Item
                                                name="new_password"
                                                rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input new password!',
                                                },
                                                ]}
                                            >
                                            <Input.Password placeholder="new password"/>
                                            </Form.Item>
                                        </div>
                                        <div className="pb-10">
                                            <label>Confirm Password</label>
                                            <Form.Item
                                                name="confirm_password"
                                                rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input confirm password!',
                                                },
                                                ]}
                                            >
                                            <Input.Password placeholder="confirm password"/>
                                            </Form.Item>
                                        </div>
                                        <div className="pb-10">
                                            <Button type="primary" htmlType="submit" block>
                                                Submit
                                            </Button>
                                            {/* <Button type="primary" block>Submit</Button> */}
                                        </div>
                                    </Form>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col xs={0} sm={0} md={0} lg={6} xl={6}></Col>
                </Row>
            </div>
        )
    }
}

export default PasswordUpdate;